Ext.define('SA.AcsTable.ViewController', {
    statics: {
        createController({model, requestedAttributeIds}) {
            var editViewObservable = new SA.controller.ViewObservable(),
                defaultViewObservable = new SA.controller.ViewObservable();

            SA.AcsTable.EditViewFactory.createEditView({model, observable: editViewObservable});
            SA.AcsTable.DefaultViewFactory.createDefaultView({model, observable: defaultViewObservable, requestedAttributeIds});

            return new SA.AcsTable.ViewController({model, editViewObservable, defaultViewObservable});
        }
    },

    constructor({model, editViewObservable, defaultViewObservable}) {
        this.model = model;
        this.editViewObservable = editViewObservable;
        this.defaultViewObservable = defaultViewObservable;
    },

    getModel() {
        return this.model;
    },

    setModeActive(mode, active) {
        mode === 'edit' ? this.editViewObservable.setActive(active) : this.defaultViewObservable.setActive(active);
    }
});